"use client";

import React, { useState } from "react";
import AccordionItemFilter from "@/components/AccordionItemFilter";
import { useRouter, useSearchParams, usePathname } from "next/navigation";

export default function Filters({
  bioTypes,
  artistGenres,
  examinerTypes,
  ggsPrimarySpecialties,
  ggsSecondarySpecialties,
  ggsClassRooms,
  taPrimarySpecialties,
  taSecondarySpecialties,
  taClassRooms,
  rcsPrimarySpecialties,
  rcsSecondarySpecialties,
}) {
  const router = useRouter();
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const pageNameFromSlug = pathname.split("/").pop();

  const filterItems = (filterName, filterValue) => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let fq = urlParams.get("fq") || "";

    // let fq = searchParams.get('fq') || "";

    let currentParams =
      window.location.href.split("?").length > 1
        ? window.location.href
            .split("?")[1]
            .replace(/&fq=.*?(?=&|$)/g, "")
            .replace(/fq=.*?(?=&|$)/g, "")
            .replace(/&page=\d+/, "")
            .replace(/page=\d+/, "")
        : "";

    if (currentParams.startsWith("&")) {
      currentParams = currentParams.substring(1);
    }
    if (!fq.includes(`${filterName}||${filterValue}`)) {
      fq += (fq === "" ? "" : ";") + `${filterName}||${filterValue}`;
    }

    const params = new URLSearchParams();
    params.set("fq", fq.replace(/&/g, "%26"));

    CloseFilters();
    router.push(
      "?" + currentParams + (currentParams != "" ? "&" : "") + params.toString()
    );
  };

  const handleVisitedFiltersForStyling = (filterName, filterValues) => {
    const alreadyChosenFilters = [];
    let fq = searchParams.get("fq");

    filterValues.map((filterValue) => {
      if (fq?.includes(`${filterName}||${filterValue.item_name}`)) {
        alreadyChosenFilters.push(filterValue.item_name);
      }
    });

    return alreadyChosenFilters;
  };

  const CloseFilters = () => {
    const filter = document.getElementById("AWS_Facets");
    const overlay = document.getElementsByClassName("js-off-canvas-overlay")[1];
    const filterButton = document.getElementById("filterButton");

    filter.classList.add("is-closed");
    filter.classList.remove("is-open");
    filter.attributes["aria-hidden"].value = "true";
    // filter.setAttribute("inert", "true");
    filterButton.attributes["aria-expanded"].value = "false";
    overlay.classList.remove("is-visible");
    overlay.classList.remove("is-closable");
  };

  return (
    <div className="cell small-shrink xlarge-3">
      <div
        // inert="false"
        className="off-canvas in-canvas-for-xlarge position-left tps-aws-facets-wrapper tps-aws-facets-off-canvas is-transition-overlap is-closed"
        id="AWS_Facets"
        data-off-canvas=""
        aria-hidden="false"
        data-n="ojnwob-n"
        data-breakpoint="xlarge"
      >
        <button
          type="button"
          className="hide-for-xlarge"
          data-close=""
          aria-expanded="true"
          onClick={() => CloseFilters()}
        >
          <span className="fal fa-times" aria-hidden></span>
          <span className="sr-only">Close</span>
        </button>
        <h2>
          Filter{" "}
          {`${
            pageNameFromSlug == "examiners"
              ? "Examiners"
              : pageNameFromSlug == "faculty"
                ? "Faculty"
                : "Results"
          }`}
        </h2>

        <ul
          id="tps-aws-facet-list"
          className="accordion"
          data-accordion=""
          data-allow-all-closed="true"
          data-multi-expand="true"
          data-slide-speed="0"
          role="tablist"
          data-i="zm3vej-i"
        >
          {bioTypes?.length > 0 && (
            <AccordionItemFilter
              key={0}
              index={0}
              title="Bio Type"
              items={bioTypes.sort((a, b) =>
                a.item_name.localeCompare(b.item_name)
              )}
              id={0}
              itemId="Bio Type"
              open={true}
              handleFilter={filterItems}
              activated="true"
              activeFacet={handleVisitedFiltersForStyling("Bio Type", bioTypes)}
            />
          )}
          {artistGenres?.length > 0 && (
            <AccordionItemFilter
              key={1}
              index={1}
              title="Artist Genre(s)"
              items={artistGenres.sort((a, b) =>
                a.item_name.localeCompare(b.item_name)
              )}
              id={1}
              itemId="Artist Genre(s)"
              open={true}
              handleFilter={filterItems}
              activated="true"
              activeFacet={handleVisitedFiltersForStyling(
                "Artist Genre(s)",
                artistGenres
              )}
            />
          )}
          {examinerTypes?.length > 0 && (
            <AccordionItemFilter
              key={2}
              index={2}
              title={`Examiner ${
                pageNameFromSlug == "examiners" ? "Type" : "Types"
              }`}
              items={examinerTypes.sort((a, b) =>
                a.item_name.localeCompare(b.item_name)
              )}
              id={2}
              itemId="Examiner Types"
              open={true}
              handleFilter={filterItems}
              activated="true"
              activeFacet={handleVisitedFiltersForStyling(
                "Examiner Types",
                examinerTypes
              )}
            />
          )}
          {ggsPrimarySpecialties?.length > 0 && (
            <AccordionItemFilter
              key={3}
              index={3}
              title="Primary Specialty (Glenn Gould School)"
              items={ggsPrimarySpecialties.sort((a, b) =>
                a.item_name.localeCompare(b.item_name)
              )}
              id={3}
              itemId="Primary Specialty (Glenn Gould School)"
              open={true}
              handleFilter={filterItems}
              activated="true"
              activeFacet={handleVisitedFiltersForStyling(
                "Primary Specialty (Glenn Gould School)",
                ggsPrimarySpecialties
              )}
            />
          )}
          {ggsSecondarySpecialties?.length > 0 && (
            <AccordionItemFilter
              key={4}
              index={4}
              title="Secondary Specialty (Glenn Gould School)"
              items={ggsSecondarySpecialties.sort((a, b) =>
                a.item_name.localeCompare(b.item_name)
              )}
              id={4}
              itemId="Secondary Specialty (Glenn Gould School)"
              open={true}
              handleFilter={filterItems}
              activated="true"
              activeFacet={handleVisitedFiltersForStyling(
                "Secondary Specialty (Glenn Gould School)",
                ggsSecondarySpecialties
              )}
            />
          )}
          {ggsClassRooms?.length > 0 && (
            <AccordionItemFilter
              key={5}
              index={5}
              title="Class Room (Glenn Gould School)"
              items={ggsClassRooms.sort((a, b) =>
                a.item_name.localeCompare(b.item_name)
              )}
              id={5}
              itemId="Class Room (Glenn Gould School)"
              open={true}
              handleFilter={filterItems}
              activated="true"
              activeFacet={handleVisitedFiltersForStyling(
                "Class Room (Glenn Gould School)",
                ggsClassRooms
              )}
            />
          )}
          {taPrimarySpecialties?.length > 0 && (
            <AccordionItemFilter
              key={6}
              index={6}
              title="Primary Specialty (Taylor Academy)"
              items={taPrimarySpecialties.sort((a, b) =>
                a.item_name.localeCompare(b.item_name)
              )}
              id={6}
              itemId="Primary Specialty (Taylor Academy)"
              open={true}
              handleFilter={filterItems}
              activated="true"
              activeFacet={handleVisitedFiltersForStyling(
                "Primary Specialty (Taylor Academy)",
                taPrimarySpecialties
              )}
            />
          )}
          {taSecondarySpecialties?.length > 0 && (
            <AccordionItemFilter
              key={7}
              index={7}
              title="Secondary Specialty (Taylor Academy)"
              items={taSecondarySpecialties.sort((a, b) =>
                a.item_name.localeCompare(b.item_name)
              )}
              id={7}
              itemId="Secondary Specialty (Taylor Academy)"
              open={true}
              handleFilter={filterItems}
              activated="true"
              activeFacet={handleVisitedFiltersForStyling(
                "Secondary Specialty (Taylor Academy)",
                taSecondarySpecialties
              )}
            />
          )}
          {taClassRooms?.length > 0 && (
            <AccordionItemFilter
              key={8}
              index={8}
              title="Class Room (Taylor Academy)"
              items={taClassRooms.sort((a, b) =>
                a.item_name.localeCompare(b.item_name)
              )}
              id={8}
              itemId="Class Room (Taylor Academy)"
              open={true}
              handleFilter={filterItems}
              activated="true"
              activeFacet={handleVisitedFiltersForStyling(
                "Class Room (Taylor Academy)",
                taClassRooms
              )}
            />
          )}
          {rcsPrimarySpecialties?.length > 0 && (
            <AccordionItemFilter
              key={9}
              index={9}
              title={`${
                pageNameFromSlug == "faculty"
                  ? "Primary Specialty"
                  : "Primary Specialty (Royal Conservatory School)"
              }`}
              items={rcsPrimarySpecialties.sort((a, b) =>
                a.item_name.localeCompare(b.item_name)
              )}
              id={9}
              itemId="Primary Specialty (Royal Conservatory School)"
              open={true}
              handleFilter={filterItems}
              activated={true}
              activeFacet={handleVisitedFiltersForStyling(
                "Primary Specialty (Royal Conservatory School)",
                rcsPrimarySpecialties
              )}
            />
          )}
          {rcsSecondarySpecialties?.length > 0 && (
            <AccordionItemFilter
              key={10}
              index={10}
              title={`${
                pageNameFromSlug == "faculty"
                  ? "Secondary Specialty"
                  : "Secondary Specialty (Royal Conservatory School)"
              }`}
              items={rcsSecondarySpecialties.sort((a, b) =>
                a.item_name.localeCompare(b.item_name)
              )}
              id={10}
              itemId="Secondary Specialty (Royal Conservatory School)"
              open={true}
              handleFilter={filterItems}
              activated="true"
              activeFacet={handleVisitedFiltersForStyling(
                "Secondary Specialty (Royal Conservatory School)",
                rcsSecondarySpecialties
              )}
            />
          )}
        </ul>
      </div>
      <div
        className="js-off-canvas-overlay is-overlay-fixed"
        onClick={() => CloseFilters()}
      ></div>
    </div>
  );
}
